import { useRef } from 'react'
import EvervizEmbed from '../EvervizEmbed'
import RichText from '../RichText'
import Carousel from '../Carousel'
import CarouselItem from '../CarouselItem'
import { IChart } from '../../@customTypes/generated/contentful'
import styles from './Charts.module.css'

interface ComponentProps {
  charts: IChart[] | undefined
  buildId: string
  sectionTitle: string | undefined
  embedCharts: boolean
}

function Charts({
  charts,
  buildId,
  sectionTitle,
  embedCharts,
}: ComponentProps) {
  const chartWrapperRef = useRef<HTMLDivElement>(null)
  const chartsClassname = `eo-charts-${buildId}`
  return (
    <>
      <style>
        {`
          @media screen and (min-width: 1024px) {
            .eo-pagination {
              display: none !important;
            }
            .${chartsClassname} {
              display: grid;
              grid-template-columns: ${new Array(charts?.length ?? 0)
                .fill('1fr')
                .join(' ')}
            }
          }
        `}
      </style>
      <div ref={chartWrapperRef}>
        <Carousel
          wrapperRef={chartWrapperRef}
          className={chartsClassname}
          sectionTitle={sectionTitle}
        >
          {charts?.map((chart, index) => (
            <CarouselItem
              key={`${index}${chart.sys.id}${chart.fields.embedId}`}
            >
              <EvervizEmbed
                uid={chart.fields.embedId}
                isLayout={chart.fields.isLayout}
                wrapperRef={chartWrapperRef}
                chartTitle={chart.fields.title}
                sectionTitle={sectionTitle}
                embedCharts={embedCharts}
              />
              {chart.fields.footnote && (
                <div className={styles.footnote}>
                  <RichText content={chart.fields.footnote} />
                </div>
              )}
            </CarouselItem>
          ))}
        </Carousel>
      </div>
    </>
  )
}
export default Charts
